import { render, staticRenderFns } from "./CustomerServicePage.vue?vue&type=template&id=07157474&scoped=true&"
import script from "./CustomerServicePage.vue?vue&type=script&lang=js&"
export * from "./CustomerServicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07157474",
  null
  
)

export default component.exports